import { gql } from "@apollo/client";

export const removeCommunicationTemplateGql = gql`
    mutation removeCommunicationTemplate($id: String!) {
        removeCommunicationTemplate(id: $id) {
            id
        }
    }
`;
